import React, { useState } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import { filter } from 'lodash'

import OrderRow from './OrderRow'
import styles from './List.module.scss'
import ConfirmModalV2 from '../ConfirmModalV2'
import { ORDERS_STATUS_OPTIONS } from '../../utils/orderStates'

const OrdersList = ({ orderDetailsRequested, selectOrder, orders, selectedOrderId, safIsUploading,
    isKiosk, ordersFilter, className }) => {
  const [showSyncingInProgress, setShowSyncingInProgress] = useState(false)
  const classNames = cn(styles.ordersList, className)

  const syncingInProgressMessage = "Orders are currently being synced. Please stop the sync to view orders."

  const onSelectOrder = (order) => {
    const orderId = order.uuid
    
    if(order.syncedAt) {
      orderDetailsRequested(orderId)
    }

    selectOrder(orderId)
  }

  const maybeOnSelectOrder = (order) => {
    if (safIsUploading) {
      setShowSyncingInProgress(true)
      return
    }

    onSelectOrder(order)
  }
  const filterOrders = (orders) => {
    switch (ordersFilter.showOrders) {
      case ORDERS_STATUS_OPTIONS.OPEN_ORDERS:
        return orders?.filter(order => order.balanceDueInCents !== 0 && order.tabName);
      case ORDERS_STATUS_OPTIONS.CLOSED_ORDERS:
        return orders?.filter(order => order.balanceDueInCents === 0 || order.paymentCompleted);
      default:
        return orders;
    }
  }

  return (
    <div className={classNames}>
      <div className={styles.headerRow}>
        <div>Tender/Name</div>
        <div>Amount</div>
        <div>Order #</div>
        <div>Created</div>
        <div>Status</div>
        <div></div>
      </div>
      <div className={styles.scrollable}>
        {filterOrders(orders).map((order) => {
          return (
            <OrderRow
              isSelected={order.uuid === selectedOrderId}
              order={order ?? {}}
              className={styles.row}
              key={order?.uuid}
              onSelect={()=> maybeOnSelectOrder (order)}
              refundable={order?.refundable}
              isKiosk={isKiosk}
            />
          )
        })}
      </div>
      {showSyncingInProgress && (
        <ConfirmModalV2
          headerText={''}
          subtext={syncingInProgressMessage}
          buttonTwoText={"OK"}
          onButtonOneClick={() => setShowSyncingInProgress(false)}
          onButtonTwoClick={() => setShowSyncingInProgress(false)}
          singleButtonOnly
        />
      )}
    </div>
  )
}

OrdersList.defaultProps = {
  orders: [],
  orderFilter : {},
}

OrdersList.propTypes = {
  orderDetailsRequested: PropTypes.func,
  selectOrder: PropTypes.array,
  selectedOrderId: PropTypes.string,
}

export default OrdersList
